<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/DnevnikPilotovJadranja_beri-sl.json';
import en from '@/Prevodi/DnevnikPilotovJadranja_beri-en.json';
import it from '@/Prevodi/DnevnikPilotovJadranja_beri-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  props: {
    user: String,
  },
  emits: [],

  data() {
    return {
      prevodi: false,
      idPilota: this.user,
      podatki: [],
      sestevki: [],
      strani: 0,
      izberiStran: 1,
      izbranZapis: [],
      Letala: [],
      LetalaMotorna: [],
      searchPilot: '',
      urejanje: false,
      dVzlet: false,
      dPristanek: false,
      dLetalo: false,
      //PODATKI ZA UREJANJE
      datum: '',
      idUrejanja: '',
      odhod_cas: '',
      krajVzleta: '',
      varianta: '',
      regLetala: '',
      imeVodje: '',
      st_letov: 0,
      nacinStarta: null,
      casLetenja: null,
      kilometri: null,
      naloga: '',
      podatkiIzbris: {},
      operativa: '', // dnevno, nocno, IFR
      opombe: '', // opombe
      showSkupno: false,
      text: '',
      types: '',
      ShowNoti: false,
      tiskam: false,
      posiljam: false,
      pot: config.baseUrl,
    };
  },

  computed: {
    prikazaneStrani() {
      const totalApi = Number(this.strani) || 1;
      const current = Number(this.izberiStran) || 1;
      const total = (this.podatki?.length || 0) === 10 ? Math.max(totalApi, current + 1) : totalApi;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      start = Math.max(1, end - 4);

      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    },
    imaVecStrani() {
      return (Number(this.strani) || 1) > 1 || ((this.podatki?.length || 0) === 10 && (Number(this.izberiStran) || 1) === 1);
    },
    imaNaslednjoStran() {
      const trenutna = Number(this.izberiStran) || 1;
      const total = Number(this.strani) || 1;
      return total > trenutna || (this.podatki?.length || 0) === 10;
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BranjePodatkov();
  },

  methods: {
    BranjePodatkov() {
      let vue = this;
      let php_podatki = new URLSearchParams();
      php_podatki.append('pilot_id', this.user);
      php_podatki.append('stran', this.izberiStran);
      axios
          .post('./api/pl_beri/jadralno/', php_podatki, {withCredentials: true})
          .then(function (response) {
            vue.podatki = response.data.podatki || [];
            vue.sestevki = response.data.sestevki;
            const stStrani = parseInt(response.data.st_strani, 10);
            vue.strani = Number.isFinite(stStrani) && stStrani > 0 ? stStrani : 1;

            if (vue.izberiStran > vue.strani) {
              vue.izberiStran = vue.strani;
              vue.BranjePodatkov();
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.sporocilo !== undefined) {
              this.text = 'Napaka pri vnosu. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri vnosu.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          });
    },
    NastaviStran(stran) {
      const novaStran = parseInt(stran, 10);
      if (!Number.isFinite(novaStran)) return;
      const trenutna = Number(this.izberiStran) || 1;
      const totalApi = Number(this.strani) || 1;
      const maxStran = (this.podatki?.length || 0) === 10 ? Math.max(totalApi, trenutna + 1) : totalApi;
      if (novaStran < 1 || novaStran > maxStran) return;
      if (novaStran === this.izberiStran) return;

      this.izberiStran = novaStran;
      this.BranjePodatkov();
    },
    PrejsnjaStran() {
      this.NastaviStran((Number(this.izberiStran) || 1) - 1);
    },
    NaslednjaStran() {
      this.NastaviStran((Number(this.izberiStran) || 1) + 1);
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.krajVzleta = this.izbranZapis[0].odhod_kraj;
      this.regLetala = this.izbranZapis[0].zrakoplov_registracija;
      this.varianta = this.izbranZapis[0].zrakoplov_model;
      this.imeVodje = this.izbranZapis[0].ime_vodje_zrakoplova;
      this.operativa = this.izbranZapis[0].operativa;
      this.opombe = this.izbranZapis[0].opombe;
      this.odhod_cas = this.izbranZapis[0].odhod_cas;
      this.datum = this.izbranZapis[0].datum;
      this.st_letov = this.izbranZapis[0].st_letov;
      this.kilometri = this.izbranZapis[0].preleteni_km;
      this.naloga = this.izbranZapis[0].naloga;
      if (this.izbranZapis[0].nacin_starta === 'Vitla') {
        this.nacinStarta = 'V';
      } else {
        this.nacinStarta = 'A';
      }
      if (this.izbranZapis[0].trajanje_dan !== null) {
        this.casLetenja = this.izbranZapis[0].trajanje_dan;
      } else {
        this.casLetenja = this.izbranZapis[0].trajanje_slepo;
      }
    },
    Details(id) {
      this.izbranZapis = this.podatki.filter(zapis => zapis.id === id);
      $(this.$refs.modalKartice).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalKartice).modal('hide');
      this.urejanje = false;
      // ponastavitev podatkov
      this.idUrejanja = '';
      this.krajVzleta = '';
      this.regLetala = '';
      this.varianta = '';
      this.imeVodje = '';
      this.operativa = '';
      this.opombe = '';
      this.odhod_cas = '';
      this.datum = '';
      this.st_letov = '';
      this.nacin_starta = null;
      this.kilometri = null;
      this.naloga = null;
    },
    PosodobiZapis(id) {
      let data = new URLSearchParams();
      data.append('id', this.idUrejanja);
      data.append('odhod_kraj', this.krajVzleta);
      data.append('zrakoplov_registracija', this.regLetala);
      data.append('zrakoplov_model', this.varianta);
      data.append('ime_vodje_zrakoplova', this.imeVodje);
      data.append('operativa', this.operativa);
      data.append('opombe', this.opombe);
      data.append('odhod_cas', this.odhod_cas);
      data.append('datum', this.datum);
      data.append('st_letov', this.st_letov);
      data.append('nacin_starta', this.nacinStarta);
      data.append('trajanje', this.casLetenja);
      data.append('kilometri', this.kilometri);
      data.append('naloga', this.naloga);
      axios.post('./api/pl_uredi/jadralno/', data, {withCredentials: true}).then((response) => {
        this.text = 'Uspešno urejeno!';
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.izbranZapis[0].odhod_kraj = this.krajVzleta;
        this.izbranZapis[0].zrakoplov_registracija = this.regLetala;
        this.izbranZapis[0].zrakoplov_model = this.varianta;
        this.izbranZapis[0].ime_vodje_zrakoplova = this.imeVodje;
        this.izbranZapis[0].operativa = this.operativa;
        this.izbranZapis[0].opombe = this.opombe;
        this.izbranZapis[0].odhod_cas = this.odhod_cas;
        this.izbranZapis[0].datum = this.datum;
        this.izbranZapis[0].st_letov = this.st_letov;
        this.izbranZapis[0].preleteni_km = this.kilometri;
        this.izbranZapis[0].naloga = this.naloga;
        this.BranjePodatkov();
        this.urejanje = false;
        // this.DetailsOff();
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (error.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodabljanju. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodabljanju.';
        }
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    OpenSkupno() {
      this.showSkupno = !this.showSkupno;
    },
    PotrdiIzbris(id) {
      this.podatkiIzbris = {
        id: id
      };
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("brisi_id", this.podatkiIzbris.id);
      axios
          .post("./api/pl_brisi/jadralno/", izbris)
          .then(function (response) {
            app.text = 'Uspešno izbrisano!';
            app.types = "Uspešno";
            app.ShowNoti = true;
            app.BranjePodatkov();
            app.DetailsOff();
            app.podatkiIzbris = {};
          })
          .catch(function (napaka) {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.napaka !== undefined) {
              this.text = 'Napaka pri posodabljanju. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri posodabljanju.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    NatisniIzpise() {
      this.tiskam = true;
      var podatki = new URLSearchParams();
      podatki.append('jadralni_podatki', JSON.stringify(this.podatki));
      axios.post('./api/pl_pdf/', podatki, {withCredentials: true}).then((response) => {
        this.tiskam = false;
        window.open(this.pot + response.data.datoteka);
      }).catch((napaka) => {
        this.tiskam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    SendToMail() {
      this.posiljam = true;
      var podatki = new URLSearchParams();
      podatki.append('jadralni_podatki', JSON.stringify(this.podatki));
      axios.post('./api/pl_pdf/', podatki, {withCredentials: true}).then((response) => {
        var podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek dnevnika pilota (jadralni)');
        podatkiMail.append('osebno', true);
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.posiljam = false;
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
        }).catch((napaka) => {
          this.posiljam = false;
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      }).catch((napaka) => {
        this.posiljam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="col-12" v-if="prevodi">
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenSkupno()">
        <i v-show="!showSkupno" class="fas fa-chevron-right"></i>
        <i v-show="showSkupno" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSkupno()">{{$t('povzetek.title')}}</button>
      <transition name="fade">
        <div v-if="showSkupno" class="container row p-2">
          <div class="col-12 col-md-6 p-1" v-if="sestevki.sestevek_30_dan !== undefined">
            <div class="container">
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno30')}}</p>
                  <div class='d-flex justify-content-between'>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_30_dan !== null">{{$t('povzetekLabel.dan')}}<br/>{{ sestevki.sestevek_30_dan }} ur</p>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_30_slepo !== null">{{$t('povzetekLabel.slepo')}}<br/>{{ sestevki.sestevek_30_slepo }} ur</p>
                  </div>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno90')}}</p>
                  <div class='d-flex justify-content-between'>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_90_dan !== null">{{$t('povzetekLabel.dan')}}<br/>{{ sestevki.sestevek_90_dan }} ur</p>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_90_slepo !== null">{{$t('povzetekLabel.slepo')}}<br/>{{ sestevki.sestevek_90_slepo }} ur</p>
                  </div>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-lg border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno365')}}</p>
                  <div class='d-flex justify-content-between'>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_365_dan !== null">{{$t('povzetekLabel.dan')}}<br/>{{ sestevki.sestevek_365_dan }} ur</p>
                    <p class="fs-6 fw-bold" v-if="sestevki.sestevek_365_slepo !== null">{{$t('povzetekLabel.slepo')}}<br/>{{ sestevki.sestevek_365_slepo }} ur</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-1" v-if="sestevki.statistika_letenja.vseh_letov !== undefined">
            <div class="container">
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.vsiO')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.vseh_letov }}</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.povprecje')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.povp_dolzina_leta }} ur</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.najveckratV')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.najveckrat_leteno }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>


  <div class="container text-white text-center" v-if="prevodi">
    <!-- ZAPISI -->
    <section class="flight-section-pregled mt-2">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-book"></i>
        </div>
        <div class="d-flex col-10 justify-content-between">
          <div>
            <h2>{{ $t('table.diaryTitle') }}</h2>
          </div>
          <div class='col-4'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!podatki.length > 0 || tiskam" @click.prevent="NatisniIzpise">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin': tiskam}"></i></button>
          </div>
          <div class='col-3'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!podatki.length > 0 || posiljam" @click.prevent="SendToMail">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin': posiljam}"></i></button>
          </div>
        </div>
      </div>

      <div class="flight-list">

        <div
            class="diary-item-pregled"
            v-for="id in podatki" :key="id.id"
            @click.prevent="Details(id.id)"
        >

          <div class="flight-date">
            <i class="fas fa-calendar"></i>
            <span>{{ id.datum }}</span>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.letalisce')}}</span>
            <strong>{{ id.odhod_kraj }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.vzlet')}}</span>
            <strong>{{ id.odhod_cas}}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.trajanje')}}</span>
            <strong>{{ (id.trajanje_dan !== null) ? id.trajanje_dan : id.trajanje_slepo }}</strong>
          </div>
          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!podatki.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>
    <!-- /ZAPISI -->
    <div class="row p-2" v-if="imaVecStrani">
      <div class="col-12 d-flex justify-content-center align-items-center flex-wrap gap-2">
        <button class="btn btn-sm btn-outline-light" @click.prevent="NastaviStran(1)" :disabled="izberiStran <= 1">«</button>
        <button class="btn btn-sm btn-outline-light" @click.prevent="PrejsnjaStran" :disabled="izberiStran <= 1">Prejsnja</button>

        <button
            v-for="stran in prikazaneStrani"
            :key="'stran-'+stran"
            class="btn btn-sm"
            :class="stran === izberiStran ? 'btn-warning text-dark' : 'btn-outline-light'"
            @click.prevent="NastaviStran(stran)">
          {{ stran }}
        </button>

        <button class="btn btn-sm btn-outline-light" @click.prevent="NaslednjaStran" :disabled="!imaNaslednjoStran">Naslednja</button>
        <button class="btn btn-sm btn-outline-light" @click.prevent="NastaviStran(strani)" :disabled="izberiStran >= strani">»</button>
      </div>
    </div>
  </div>

  <!-- PILOT PODROBNO -->
  <div class="modal modal-kartica" ref="modalKartice" tabindex="-1" role="dialog" v-if="prevodi">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
        <div class='d-flex justify-content-end'>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <div class='modal-header'>
          <h5 class="card-title"><i class="fas fa-paper-plane fa-lg"></i> Izbran zapis</h5>
        </div>
        <div class="modal-body col-12" v-if="!this.urejanje">
          <ul class='list-group list-group-flush'>
            <li class="list-group-item list-dark">{{$t('modal.datum')}} {{izbranZapis[0].datum}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.zrakoplov')}}{{izbranZapis[0].zrakoplov_model}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].zrakoplov_registracija}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.odhod')}} {{izbranZapis[0].odhod_cas}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.krajO')}} {{izbranZapis[0].odhod_kraj}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.kilometri')}} {{izbranZapis[0].preleteni_km}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.trajanjeDan')}} {{izbranZapis[0].trajanje_dan}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.trajanjeSlepo')}} {{izbranZapis[0].trajanje_slepo}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.stLetov')}} {{izbranZapis[0].st_letov}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.nacinStarta')}} {{izbranZapis[0].nacin_starta}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.vodjaZ')}} {{izbranZapis[0].ime_vodje_zrakoplova}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].opombe}}</li>
          </ul>
        </div>
        <ul class='list-group list-group-flush' v-else>
          <!---ODHOD ČAS--->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.casO')}}
            <span class='text-lorange'>{{izbranZapis[0].odhod_cas}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="odhod_cas" v-model="odhod_cas" required />
          </li>
          <!---ODHOD KRAJ--->
          <li class='list-group-item list-dark'>
            {{$t('modal.krajO')}}
            <span class='text-lorange'>{{izbranZapis[0].odhod_kraj}}</span>
            <div class="container">
              <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" v-model="krajVzleta" required />
            </div>
          </li>
          <!-- MODEL, VARIANTA ZRAKOPLOVA-->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.model')}}
            <span class='text-lorange'>{{izbranZapis[0].zrakoplov_model}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="varianta" v-model="varianta" required />
          </li>
          <!-- REGISTRACIJA -->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.reg')}}
            <span class='text-lorange'>{{izbranZapis[0].regLetala}}</span>
            <div class="container">
              <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" v-model="regLetala" required />
            </div>
          </li>
          <!-- NAČIN ŠTARTA -->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.nacinStarta')}}
            <span class='text-lorange'>{{izbranZapis[0].nacin_starta}}</span>
            <label :class="{ hidden: nacinStarta.length > 0 }" class="label" for="nacinStarta">{{$t('labelsLJ.nacinStarta')}}</label>
            <select class="input border-0 rounded-4 p-2 fs-5" id="nacinStarta" v-model="nacinStarta">
              <option value="A">{{$t('optionsLJ.aerozaprega')}}</option>
              <option value="V">{{$t('optionsLJ.vitla')}}</option>
            </select>
          </li>
          <!-- IME VODJE ZRAKOPLOVA-->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.vodjaZ')}}
            <span class='text-lorange'>{{izbranZapis[0].ime_vodje_zrakoplova}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="imeVodje" v-model="imeVodje" required />
          </li>
          <!-- PRELETENI KILOMETRI -->
          <li class='list-group-item list-dark'>
            <label :class="{ hidden: naloga.length > 0 }" class="label-time p-2" for="naloga">{{$t('labelsLJ.naloga')}}</label>
            <span class='text-lorange'>{{izbranZapis[0].naloga}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" placeholder="TTOF" id="naloga" v-model="naloga" required />
          </li>
          <!-- ŠT. PRISTANKOV -->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.stPristankov')}}
            <span class='text-lorange'>{{izbranZapis[0].st_letov}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="pristanki" v-model="st_letov" required />
          </li>
          <!-- ČAS LETENJA -->
          <li class='list-group-item list-dark'>
            <label :class="{ hidden: casLetenja.length > 0 }" class="label-time p-2" for="casLetenja">{{$t('labelsLJ.skupniCas')}}</label>
            <span class='text-lorange'>{{(izbranZapis[0].trajanje_dan !== null ? izbranZapis[0].trajanje_dan : izbranZapis[0].trajanje_slepo)  }}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="TTOF" id="casLetenja" v-model="casLetenja" required />
          </li>
          <!-- PRELETENI KILOMETRI -->
          <li class='list-group-item list-dark'>
            <label :class="{ hidden: kilometri.length > 0 }" class="label-time p-2" for="kilometri">{{$t('labelsLJ.kilometri')}}</label>
            <span class='text-lorange'>{{izbranZapis[0].preleteni_km}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="number" placeholder="TTOF" id="kilometri" v-model="kilometri" required />
          </li>
          <!--OPERATIVNI POGOJI-->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.op')}}
            <span class='text-lorange'>{{izbranZapis[0].operativa}}</span>
            <div class="input border-0 rounded-4 p-2 fs-5">
              <div class="row">
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="dan" value="dan" />
                  <label class="p-1" style="color: white;" for="operativa">  {{$t('labelsLJ.opD')}}</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="slepo" value="slepo" />
                  <label class="p-1" style="color: white;" for="operativa">  {{$t('labelsLJ.opN')}}</label>
                </div>
              </div>
            </div>
          </li>
          <!-- OPOMBA -->
          <li class='list-group-item list-dark'>
            {{$t('labelsLJ.opomba')}}
            <span class='text-lorange'>{{izbranZapis[0].opombe}}</span>
            <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opombe" v-model="opombe" rows="6" autocomplete="off"></textarea>
          </li>
        </ul>
        <div class="modal-footer col-12">
          <div class="modal-footer col-12">
            <button class="btn btn-outline-warning" v-if="!this.urejanje" @click.prevent="UrediZapis(izbranZapis[0].id)"><i class="fas fa-user-edit"></i> {{$t('buttons.urediPodatke')}} </button>
            <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapis(izbranZapis[0].id)"><i class="fas fa-sync-alt"></i> {{$t('buttons.posodobiPodatke')}} </button>&nbsp;
            <button class="btn btn-outline-danger" v-if="!this.urejanje" @click.prevent="PotrdiIzbris(izbranZapis[0].id)"><i class="fas fa-trash"></i> {{$t('buttons.brisiZapis')}} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
  <div class='col-12 p-5'></div>
</template>